"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Loader = _interopRequireDefault(require("../Loader"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Iframe =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Iframe, _PureComponent);

  function Iframe(props) {
    var _this;

    _classCallCheck(this, Iframe);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Iframe).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setIframeHeight", function () {
      var iframe = _this.innerRef.current;
      var doc = iframe.contentWindow.document;
      var nodes = doc.querySelectorAll('*'); // fix IE nodeList behaviour

      nodes = Array.prototype.slice.call(nodes);
      var height = 0;
      nodes.forEach(function (n) {
        // potential performance issue
        if (n.scrollHeight && n.scrollHeight > height) height = n.scrollHeight;
      });
      iframe.style.visibility = 'hidden';
      iframe.style.height = '10px'; // reset to minimal height ...
      // IE opt. for bing/msn needs a bit added or scrollbar appears

      iframe.style.height = "".concat(height, "px");
      iframe.style.visibility = 'visible';
    });

    _defineProperty(_assertThisInitialized(_this), "load", function () {
      var loading = _this.state.loading;

      if (!loading) {
        _this.setState({
          loading: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleIgnoreClick", function (e) {
      return (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnLoad", function (e) {
      var iframe = _this.innerRef.current;
      var autoHeight = _this.props.autoHeight;
      if (autoHeight) _this.setIframeHeight();

      _this.setState({
        loaded: true,
        loading: false
      }, function () {
        iframe.style.display = 'block';
        var onLoad = _this.props.onLoad;
        if (onLoad) onLoad(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnError", function (e) {
      var onError = _this.props.onError;
      if (onError) onError(e);
    });

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Iframe.className];
      var propNames = ['readOnly'];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      (0, _lib.addClassByPropName)(names, _this.state, ['loaded']);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "renderPlaceHolder", function () {
      var _this$state = _this.state,
          loaded = _this$state.loaded,
          loading = _this$state.loading;
      var _this$props = _this.props,
          loaderNode = _this$props.loaderNode,
          emptyNode = _this$props.emptyNode;
      var output;

      if (!loading && !loaded) {
        output = emptyNode;
      }

      if (loading) {
        output = loaderNode;
      }

      if (loaded) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "placeholder"
      }, output);
    });

    var src = props.src,
        _loading = props.loading;
    _this.state = {
      prevProps: {
        src: src,
        loading: _loading
      },
      loaded: false,
      loading: _loading
    };
    return _this;
  }

  _createClass(Iframe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          src = _this$props2.src,
          visible = _this$props2.visible;

      if (src && visible) {
        this.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
          src = _this$props3.src,
          visible = _this$props3.visible;

      if (src && src !== prevProps.src || visible && visible !== prevProps.visible) {
        this.load();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var iframe = this.innerRef.current;
      iframe.removeEventListener('load', this.handleOnLoad, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          as = _this$props4.as,
          onLoad = _this$props4.onLoad,
          wrapperRef = _this$props4.wrapperRef,
          visible = _this$props4.visible,
          emptyNode = _this$props4.emptyNode,
          loaderNode = _this$props4.loaderNode,
          readOnly = _this$props4.readOnly,
          disabled = _this$props4.disabled,
          fluid = _this$props4.fluid,
          title = _this$props4.title,
          innerRef = _this$props4.innerRef,
          src = _this$props4.src,
          name = _this$props4.name,
          width = _this$props4.width,
          height = _this$props4.height,
          autoHeight = _this$props4.autoHeight,
          rest = _objectWithoutProperties(_this$props4, ["as", "onLoad", "wrapperRef", "visible", "emptyNode", "loaderNode", "readOnly", "disabled", "fluid", "title", "innerRef", "src", "name", "width", "height", "autoHeight"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var iframeRef = innerRef || this.innerRef;
      var classNames = this.classNames();
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        ref: wrapperRef,
        disabled: disabled,
        className: classNames
      }), readOnly || disabled ? _react.default.createElement("div", {
        className: "ignore-click",
        onMouseDown: this.handleIgnoreClick
      }) : null, this.renderPlaceHolder(), _react.default.createElement("iframe", {
        ref: iframeRef,
        title: title,
        name: name,
        src: src,
        width: width || '100%',
        height: height || '100%',
        onLoad: this.handleOnLoad,
        onError: this.handleOnError
      }, _react.default.createElement("p", null, "Your browser does not support iframes.")));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var src = props.src,
          loading = props.loading;
      return {
        // Store the previous props in state
        prevProps: {
          src: src,
          loading: loading
        },
        loading: prevProps.loading !== loading ? loading : state.loading
      };
    }
  }]);

  return Iframe;
}(_react.PureComponent);

exports.default = Iframe;

_defineProperty(Iframe, "className", 'MHub-Iframe');

_defineProperty(Iframe, "propTypes", {
  as: _common.customPropTypes.as,
  src: _propTypes.default.string,
  title: _propTypes.default.string,
  name: _propTypes.default.string,
  width: _common.customPropTypes.stringOrNumber,
  height: _common.customPropTypes.stringOrNumber,
  autoHeight: _propTypes.default.bool,
  fluid: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  visible: _propTypes.default.bool,
  innerRef: _common.customPropTypes.ref,
  wrapperRef: _common.customPropTypes.ref,
  onLoad: _propTypes.default.func,
  onError: _propTypes.default.func,
  loaderNode: _propTypes.default.node,
  emptyNode: _propTypes.default.node
});

_defineProperty(Iframe, "defaultProps", {
  as: 'div',
  src: null,
  name: null,
  title: null,
  width: null,
  height: null,
  autoHeight: false,
  fluid: false,
  readOnly: false,
  disabled: false,
  visible: true,
  innerRef: null,
  wrapperRef: null,
  onLoad: null,
  onError: null,
  loaderNode: _react.default.createElement(_Loader.default, {
    color: "grey"
  }),
  emptyNode: _react.default.createElement("p", null, "No iframe")
});